import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { Member } from 'src/app/interfaces/member.interface';
import confetti from 'canvas-confetti';

@Component({
    selector: 'app-member-name',
    templateUrl: 'member-name.component.html',
    styleUrls: [],
    standalone: false
})
export class MemberNameComponent implements OnChanges {
    isBirthday = false;

    @Input() member: Member;
    @Input() confettiEnabled: boolean = false; // Confetti should only work on profile page. It looks weird on other pages because the member name redirects or opens another view.

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.member) {
            const today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);
            if (changes.member.currentValue.birthdate) {
                const birthdate = new Date(changes.member.currentValue.birthdate);
                birthdate.setHours(0);
                birthdate.setMinutes(0);
                birthdate.setSeconds(0);
                birthdate.setMilliseconds(0);
                birthdate.setFullYear(today.getFullYear());
                this.isBirthday = +today === +birthdate;
            }
        }
    }

    celebrate(event: MouseEvent) {
        if(this.confettiEnabled) {
            // Calculate the origin relative to the viewport
            const rect = (event.target as HTMLElement).getBoundingClientRect(); // gets position of element in dom
            const x = (rect.left + rect.right) / 2 / window.innerWidth; // calculates middle position on x axis
            const y = (rect.top + rect.bottom) / 2 / window.innerHeight; // calculates middle position on y axis
        
            confetti({
                angle: 45,
                particleCount: 75,
                spread: 35,
                decay: 0.85,
                startVelocity: 40,
                origin: { x, y },
            });
          
            // Clear confetti after a 3000 ms
            setTimeout(() => confetti.reset(), 3000);
          }
        }
}


